// SPDX-FileCopyrightText: Copyright 2025 New Vector Ltd.
// SPDX-FileCopyrightText: Copyright 2025, 2026 Element Creations Ltd.
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial

import cx from "classnames";
import { FormattedMessage } from "react-intl";

import styles from "./footer.module.css";
import { ElementLogotype } from "./logo";

type RootProps = React.PropsWithChildren<{ className?: string }>;
export const Root: React.FC<RootProps> = ({
  children,
  className,
}: RootProps) => (
  <footer className={cx(className, styles["root"])}>{children}</footer>
);

export const ElementLogo: React.FC = () => (
  <a
    href="https://enterprise-im.webcal.ai/"
    target="_blank"
    rel="noopener noreferrer"
    className={styles["element-logo"]}
  >
    <ElementLogotype />
  </a>
);

export const Divider: React.FC = () => (
  // oxlint-disable-next-line jsx-a11y/control-has-associated-label
  <div
    // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role
    role="separator"
    aria-orientation="vertical"
    className={styles["divider"]}
  />
);

type SectionProps = React.PropsWithChildren;
export const Section: React.FC<SectionProps> = ({ children }: SectionProps) => (
  <div className={styles["section"]}>{children}</div>
);

// "now" is the load time of the application. It only matters for rendering the
// "current year" in the copyright notice
const now = new Date();

export const CopyrightNotice: React.FC = () => (
  <div className={styles["copyright-notice"]}>
    <FormattedMessage
      id="footer.copyright_notice"
      defaultMessage="Copyright © {now, date, ::yyyy}"
      description="The copyright notice on the footer"
      values={{ now }}
    />
  </div>
);
